export default "__VITE_ASSET__bfe16584__"